import React, { useState } from 'react'

/**
 * TitleCell component - displays a title with truncation and tooltip
 * @param {string} title - The full title to display
 * @param {number} maxLength - Maximum length before truncation (default: 40)
 */
const TitleCell = ({ title, maxLength = 40 }) => {
  const [showTooltip, setShowTooltip] = useState(false)

  // Handle empty/null titles
  if (!title) {
    return <span style={{ color: '#999', fontStyle: 'italic' }}>No Title</span>
  }

  // Truncate title if too long
  const displayTitle = title.length > maxLength 
    ? title.substring(0, maxLength) + '...' 
    : title

  const containerStyle = {
    position: 'relative',
    display: 'inline-block',
    maxWidth: '100%'
  }

  const textStyle = {
    color: 'inherit',
    wordBreak: 'break-word'
  }

  const tooltipStyle = {
    position: 'absolute',
    bottom: '100%',
    left: '0',
    backgroundColor: '#333',
    color: '#fff',
    padding: '8px 12px',
    borderRadius: '4px',
    fontSize: '12px',
    whiteSpace: 'normal',
    zIndex: 9999,
    marginBottom: '5px',
    maxWidth: '400px',
    wordWrap: 'break-word',
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    pointerEvents: 'none'
  }

  // Only show tooltip if title is truncated
  const isTruncated = title.length > maxLength

  return (
    <div 
      style={containerStyle}
      onMouseEnter={() => isTruncated && setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <span style={textStyle} title={isTruncated ? title : undefined}>
        {displayTitle}
      </span>
      
      {showTooltip && isTruncated && (
        <div style={tooltipStyle}>
          {title}
        </div>
      )}
    </div>
  )
}

export default TitleCell
